import React from 'react'
import { connect } from 'react-redux'
import { selectDesign } from '../../../store/site'
import TraitsProvider from 'constructicon/traits-provider'

const Theme = ({
  children,
  colors: {
    primary,
    secondary,
    tertiary,
    dark,
    light
  } = {},
  fonts: {
    head = {},
    body = {},
    button = {}
  } = {}
}) => {
  const traits = {
    colors: {
      primary,
      secondary,
      tertiary,
      dark: dark || '#272727',
      light: light || 'white',
      transparent: 'transparent'
    },
    fonts: {
      head: head.family,
      body: body.family,
      button: button.family
    },
    treatments: {
      head: {
        fontFamily: head.family,
        fontWeight: head.weight || 400,
        textTransform: head.uppercase === 'yes' && 'uppercase',
        lineHeight: 1.1,
        letterSpacing: head.spacing === 'condensed' ? '-0.1rem'
          : head.spacing === 'expanded' && '0.1rem'
      },
      body: {
        fontFamily: body.family,
        fontWeight: body.weight || 400,
        textTransform: body.uppercase === 'yes' && 'uppercase'
      },
      button: {
        fontFamily: button.family,
        fontWeight: button.weight || 400,
        textTransform: button.uppercase === 'yes' && 'uppercase'
      },
      container: {
        maxWidth: '67.5rem'
      }
    },
    shadows: {
      full: '0 5px 10px rgba(0,0,0,0.125)',
      bottom: '0 5px 5px rgba(0,0,0,0.125)'
    }
  }

  return (
    <TraitsProvider traits={traits}>
      {children}
    </TraitsProvider>
  )
}

const mapState = (state) => selectDesign(state)

export default connect(mapState)(Theme)



// WEBPACK FOOTER //
// ./components/utils/Theme/index.js